export default "__VITE_ASSET__9ed030ce__"